var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.dialogVisible,
            width: "500px",
            "append-to-body": "",
            "before-close": _vm.handleClose,
            "custom-class": "modifyTheUserPassword",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formLabelAlign",
                  attrs: {
                    "label-position": "right",
                    rules: _vm.rules,
                    "label-width": "140px",
                    model: _vm.formLabelAlign,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "oldPass",
                      attrs: { label: "旧   密   码：", prop: "oldPass" },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: _vm.formLabelAlignEye.oldPass
                              ? ""
                              : "password",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.formLabelAlign.oldPass,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabelAlign, "oldPass", $$v)
                            },
                            expression: "formLabelAlign.oldPass",
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              slot: "suffix",
                              "icon-class": _vm.formLabelAlignEye.oldPass
                                ? "blink"
                                : "closedEyes",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showView("oldPass")
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "newPass",
                      attrs: { label: "新   密   码：", prop: "newPass" },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: _vm.formLabelAlignEye.newPass
                              ? ""
                              : "password",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.formLabelAlign.newPass,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabelAlign, "newPass", $$v)
                            },
                            expression: "formLabelAlign.newPass",
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              slot: "suffix",
                              "icon-class": _vm.formLabelAlignEye.newPass
                                ? "blink"
                                : "closedEyes",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showView("newPass")
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认新密码：", prop: "newPass2" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: _vm.formLabelAlignEye.newPass2
                              ? ""
                              : "password",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.formLabelAlign.newPass2,
                            callback: function ($$v) {
                              _vm.$set(_vm.formLabelAlign, "newPass2", $$v)
                            },
                            expression: "formLabelAlign.newPass2",
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              slot: "suffix",
                              "icon-class": _vm.formLabelAlignEye.newPass2
                                ? "blink"
                                : "closedEyes",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showView("newPass2")
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }